import { render, staticRenderFns } from "./ShipmentsMap.vue?vue&type=template&id=273a2b0a&scoped=true&"
import script from "./ShipmentsMap.vue?vue&type=script&lang=js&"
export * from "./ShipmentsMap.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentsMap.vue?vue&type=style&index=0&id=273a2b0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273a2b0a",
  null
  
)

export default component.exports